import { render, staticRenderFns } from "./FormLibrary.vue?vue&type=template&id=4b5143c4&scoped=true&"
import script from "./FormLibrary.vue?vue&type=script&lang=js&"
export * from "./FormLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5143c4",
  null
  
)

export default component.exports